import React from 'react'
import { Tabs } from '@driftt/tide-core-legacy'
import CompanyTab from '../CompanyTab'
import ModalSidesheet from '../../Sidesheet/modal'
import ContactInfo from '../ContactInfo'

const PresenceSidesheet = ({ onClose, user, ...props }) => {
  const tabData = [
    {
      title: 'Contact',
      component: () => <ContactInfo user={user} anonymousId={_.get(user, 'meta.anonymousId', '')} {...props} />
    },
    {
      title: 'Account',
      component: () => <CompanyTab orgId= {user.orgId} company={user.company} endUserId={user.endUserId} />
    }
  ]
  const content =
    props.revealContext.liveReveal || props.revealContext.isEligibleForLiveRevealUpgradeFlow ? (
      <Tabs data={tabData} />
    ) : (
      tabData[0].component()
    )

  return (
    <ModalSidesheet onClose={onClose} title="Start a Conversation">
      {content}
    </ModalSidesheet>
  )
}

export default PresenceSidesheet



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/PresenceSidesheet/index.js